/**
 * LocalStorage facade with JSON serialization.
 * Use string keys; values are JSON-serialized on set and parsed on get.
 */
export const LocalStorage = {
  _parseIn(data: unknown): string {
    return JSON.stringify(data);
  },

  _parseOut(data: string | null): unknown {
    if (data == null || data === '') return null;
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  },

  set(name: string, data: unknown): void {
    localStorage.setItem(name, this._parseIn(data));
  },

  get(name: string): unknown {
    return this._parseOut(localStorage.getItem(name));
  },

  has(name: string): boolean {
    return this._parseOut(localStorage.getItem(name)) != null;
  },

  remove(name: string): void {
    localStorage.removeItem(name);
  },

  clear(): void {
    localStorage.clear();
  },
} as const;

/**
 * SessionStorage facade with JSON serialization.
 * Use string keys; values are JSON-serialized on set and parsed on get.
 */
export const SessionStorage = {
  _parseIn(data: unknown): string {
    return JSON.stringify(data);
  },

  _parseOut(data: string | null): unknown {
    if (data == null || data === '') return null;
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  },

  set(name: string, data: unknown): void {
    sessionStorage.setItem(name, this._parseIn(data));
  },

  get(name: string): unknown {
    return this._parseOut(sessionStorage.getItem(name));
  },

  has(name: string): boolean {
    return this._parseOut(sessionStorage.getItem(name)) != null;
  },

  remove(name: string): void {
    sessionStorage.removeItem(name);
  },

  clear(): void {
    sessionStorage.clear();
  },
} as const;
